import React, { useRef, useState } from "react";
import { DashboardLayout } from "./Dashboard";
import { useLocation, useNavigate, useParams } from "react-router";
import { useGetData } from "@/hooks/useGetData";
import {
  User,
  Users,
  Briefcase,
  Building2,
  Stethoscope,
  UserCheck,
  Phone,
  Mail,
  MapPin,
  Hash,
  Calendar,
  TrendingUp,
  Activity,
  FileText,
  Clock,
  ArrowLeft,
  Edit,
  Edit2,
  Trash2,
  Plus,
  Eye,
  Pencil,
  Download,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogHeader } from "@/components/ui/dialog";
import OrganizationForm from "@/components/OrganizationForm";
import {
  formatOrganizationTimezoneDisplay,
  formatUSPhoneNumber,
  getPromise,
  getPromiseToast,
} from "@/utils/helpers";
import AxiosInstance from "@/utils/AxiosInstance";
import { useOrg } from "@/contexts/useOrg";
import MyDialogContent from "@/components/MyDialogContent";
import RHFWrapper from "@/components/RHFWrapper";
import Grid from "@/components/Grid";
import RhfInput from "@/components/rhfFields/RhfInput";
import RhfSelect from "@/components/rhfFields/RhfSelect";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Card } from "@/components/ui/card";
import LoaderWrapper from "./LoaderWrapper";
import {
  DashboardcardShimmer,
  HorizontalCardShimmer,
} from "@/components/Shimmer";
import CityStateZipcode from "@/components/CityStateZipcode";
import { DialogContent, DialogTitle } from "@radix-ui/react-dialog";
import { Label } from "recharts";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import * as XLSX from "xlsx";
import MyTable from "@/components/MyTable"
import TableWithSearch from "@/components/TableWithSearch";
import { facilitiesTableHeaders } from "@/utils/tablesData";
import RhfAddressAutoComplete from "@/components/rhfFields/RhfAddressAutoComplete";
const OrganizationProfile = () => {
  // const { state } = useLocation();
  const { id } = useParams();
  const [orgData, setOrgData] = useState<any>(null);
  const nav = useNavigate();
  const { loading, err } = useGetData(
    "/organizations/" + id,
    {},
    false,
    true,
    (err, data) => {
      if (data && !err) {
        setOrgData(data?.data);
      }
    },
  );
  const {
    apiData: statsApiData,
    loading: statsLoading,
    err: statsErr,
    fetchData: refetchStats,
  } = useGetData(
    "/organizations/stats",
    { orgId: orgData?._id },
    false,
    !!orgData,
  );
  // console.log(statsData?.data?.[0]?.stats)
  const [isBulkUploadOpen, setIsBulkUploadOpen] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadErrors, setUploadErrors] = useState<{ row: number; error: string }[]>([]);
  const [isUploadErrorsOpen, setIsUploadErrorsOpen] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const statsData = statsApiData?.data?.[0]?.stats;
  const [facilities, setFacilities] = useState<any>([]);
  const { loading: facLoading, err: facErr } = useGetData(
    "/facilities",
    { orgId: id },
    false,
    true,
    (err, data) => {
      if (data && !err) {
        setFacilities(data?.data?.facilities || []);
      }
    },
  );
  const [activeTab, setActiveTab] = useState("general");
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [isFacilityPopupOpen, setIsFacilityPopupOpen] = useState(false);
  const [facilityDialogOpen, setFacilityDialogOpen] = useState(false);
  const [selectedFacility, setSelectedFacility] = useState<any>(null);
  const [facilityMode, setFacilityMode] = useState<"view" | "edit">("view");
  const [btnLoading, setBtnLoading] = useState(false);
  const { setOrganizations: setOrgUniversal } = useOrg() as any;
  const [formmode, setformmode] = useState(null);
  function modifyOrg(newOrg: any) {
    setOrgUniversal((p: any) => {
      if (Array.isArray(p)) {
        return (p as any[]).map((org: any) =>
          org?._id == newOrg?._id ? newOrg : org,
        );
      }
      return [newOrg];
    });
    setOrgData(newOrg);
  }

  const facilityTimezoneOptions = [
    { label: "Eastern Time (ET)", value: "America/New_York" },
    { label: "Central Time (CT)", value: "America/Chicago" },
    { label: "Mountain Time (MT)", value: "America/Denver" },
    { label: "Pacific Time (PT)", value: "America/Los_Angeles" },
  ];

  const handleAddUpdateOrg = async (
    formData: any,
    cb = () => {},
    step: any,
    isNew: any,
  ) => {
    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);
    try {
      setBtnLoading(true);
      let data = {};
      const res: any = await AxiosInstance().put("/organizations/" + id, {
        ...formData,
        step,
      });
      modifyOrg((res?.data?.data as any) || {});
      // step == 3 && toast.success("Organization updated succcessfully");
      if (step == 3) {
        resolveFn(
          !isNew
            ? "Organization updated succcessfully"
            : "Organization created succcessfully",
        );
      } else {
        resolveFn("Data Saved");
      }
      console.log("UPDATED ORG", data);
      cb();
    } catch (error: any) {
      console.log(error?.message);
      rejectFn(error);
      // getErrToast(error);
    } finally {
      setBtnLoading(false);
    }
  };
  async function handleAddfacility(formdata: any) {
    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);
    try {
      setBtnLoading(true);
      const res: any = await AxiosInstance().post("/facilities", {
        organizationId: orgData?._id,
        ...formdata,
      });
      setFacilities((prev: any) => [...prev, res?.data?.data]);
      // Refetch stats to update the facilities count in the stats cards
      if (refetchStats) {
        refetchStats();
      }
      resolveFn("Facility added successfully");
    } catch (error: any) {
      rejectFn(error);
    } finally {
      setBtnLoading(false);
    }
    setIsFacilityPopupOpen(false);
  }
  async function handleUpdateFacility(formdata: any) {
    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);
    try {
      setBtnLoading(true);
      const res: any = await AxiosInstance().put(
        `/facilities/${selectedFacility._id}`,
        formdata,
      );
      setFacilities((prev: any) =>
        prev.map((f: any) =>
          f._id === selectedFacility._id ? res?.data?.data : f,
        ),
      );
      // Refetch stats to update the facilities count in the stats cards
      if (refetchStats) {
        refetchStats();
      }
      resolveFn("Facility updated successfully");
    } catch (error: any) {
      rejectFn(error);
    } finally {
      setBtnLoading(false);
    }
    setFacilityDialogOpen(false);
  }
  const handleView = (facility: any) => {
    setSelectedFacility(facility);
    setFacilityMode("view");
    setFacilityDialogOpen(true);
  };
  const handleEdit = (facility: any) => {
    setSelectedFacility(facility);
    setFacilityMode("edit");
    setFacilityDialogOpen(true);
  };
  // Temporary stats data - will be replaced with orgData.stats in future
  const stats = [
    // { label: 'Admins', count: 20, icon: User, color: 'bg-emerald-50 text-emerald-600', bgColor: 'bg-emerald-500' },
    {
      label: "Patients",
      count: statsData?.patients || 0,
      icon: Users,
      color: "bg-cyan-50 text-cyan-600",
      bgColor: "bg-cyan-500",
      onClick: () => nav("/patients?orgId=" + id),
    },
    {
      label: "Caretakers",
      count: statsData?.caretakers || 0,
      icon: UserCheck,
      color: "bg-purple-50 text-purple-600",
      bgColor: "bg-purple-500",
      onClick: () => nav("/caretakers?orgId=" + id),
    },
    {
      label: "Providers",
      count: statsData?.providers || 0,
      icon: Stethoscope,
      color: "bg-pink-50 text-pink-600",
      bgColor: "bg-pink-500",
      onClick: () => nav("/providers?orgId=" + id),
    },
    {
      label: "Practitioners",
      count: statsData?.practitioners || 0,
      icon: Briefcase,
      color: "bg-indigo-50 text-indigo-600",
      bgColor: "bg-indigo-500",
      onClick: () => nav("/practitioners?orgId=" + id),
    },
    {
      label: "Facilities",
      count: statsData?.facilities || 0,
      icon: Building2,
      color: "bg-amber-50 text-amber-600",
      bgColor: "bg-amber-500",
      onClick: () => setActiveTab("facilities"),
    },
  ];
  const tabs = [
    { id: "general", label: "General Details" },
    { id: "biller", label: "Biller Details" },
    { id: "billing", label: "Billing Information" },
    // { id: 'display', label: 'Display Picture' },
    { id: "facilities", label: "Facilites" },
    // { id: 'settings', label: 'Default Settings' }
  ];
  const actionButtons = [
    // { label: 'Assign Roles', icon: UserCheck, color: 'bg-white g-white hover:bg-gray-50 border border-gray-300 text-gray-700' },
    // { label: 'Add Admin', icon: User, color: 'bg-white hover:bg-gray-50 border border-gray-300 text-gray-700' },
    {
      label: "Add Facility",
      onClick: () => setIsFacilityPopupOpen(true),
      icon: Building2,
      color: "bg-white hover:bg-gray-50 border border-gray-300 text-gray-700",
    },
    {
      label: "Billing Analysis",
      icon: TrendingUp,
      onClick: () => {
        nav("billing-analysis");
      },
      color: "bg-white hover:bg-gray-50 border border-gray-300 text-gray-700",
    },
    {
      label: "Upload Patients",
      icon: Activity,
      onClick: () => setIsBulkUploadOpen(true),
      color: "bg-white hover:bg-gray-50 border border-gray-300 text-gray-700",
    },
    // { label: 'Device Stats', icon: Activity, color: 'bg-white hover:bg-gray-50 border border-gray-300 text-gray-700' },
    // { label: 'Time Usage', icon: Clock, color: 'bg-white hover:bg-gray-50 border border-gray-300 text-gray-700' },
    // { label: 'Readings', icon: FileText, color: 'bg-white hover:bg-gray-50 border border-gray-300 text-gray-700' },
    // { label: 'Latest Reading Analysis', icon: Activity, color: 'bg-white hover:bg-gray-50 border border-gray-300 text-gray-700' }
  ];

const downloadTemplate= async () => {
  try {
    // 1. Fetch file from /public
    const response = await fetch("/SAMPLE_PATIENT_DATA.xlsx");
    const arrayBuffer = await response.arrayBuffer();

    // 2. Read workbook
    const workbook = XLSX.read(arrayBuffer, { type: "array" });

    // 3. Download it again (re-generated)
    XLSX.writeFile(workbook, "SAMPLE_PATIENT_DATA.xlsx");

    toast.success("Template downloaded successfully!");
  } catch (error) {
    console.error("Error downloading template:", error);
    toast.error("Failed to download template");
  }
};
const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
  const file = e.target.files?.[0];
  if (!file) return;

  const { pr, resolveFn, rejectFn } = getPromise();
  getPromiseToast(pr);
  setIsUploading(true);

  try {
    const formData = new FormData();
    formData.append("excelFile", file);
    formData.append('organizationId', id || "");

    const { data } = await AxiosInstance().post(
      "/patients/bulk",
      formData,
      { isFormData: true } as any // interceptor handles it
    ) as any;

    // Handle response with created/failed counts and errors
    if (data?.data) {
      const { created = 0, failed = 0, errors = [] } = data.data as any;
      
      // Show summary message with counts
      const summaryMessage = `Bulk upload completed: ${created} created, ${failed} failed`;
      if (created > 0 && failed === 0) {
        toast.success(summaryMessage);
        resolveFn(`Patients uploaded successfully: ${created} created`);
      } else if (failed > 0) {
        toast.info(summaryMessage);
        resolveFn(summaryMessage);
      } else {
        toast.success(summaryMessage);
        resolveFn(summaryMessage);
      }

      // Show errors in a popup dialog (proper tarike se)
      if (errors && errors.length > 0) {
        const errorList = errors.map((errItem: any) => ({
          row: errItem.row ?? 0,
          error: errItem.error || "Unknown error",
        }));
        setUploadErrors(errorList);
        setIsUploadErrorsOpen(true);
      }
    } else {
      resolveFn("Patients uploaded successfully");
    }

    setIsBulkUploadOpen(false);
    if (fileInputRef.current) fileInputRef.current.value = "";
    refetchStats();
  } catch (error: any) {
    console.error("File upload error:", error);
    rejectFn(error);
  } finally {
    setIsUploading(false);
  }
};


  if (loading && !orgData) {
    return (
      <DashboardLayout activePage="organizations">
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading organization details...</p>
          </div>
        </div>
      </DashboardLayout>
    );
  }
  if (err || !orgData) {
    return (
      <DashboardLayout activePage="organizations">
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-center">
            <div className="text-red-500 text-xl mb-2">
              Error loading organization
            </div>
            <p className="text-gray-600">
              {err || "Organization data not found"}
            </p>
          </div>
        </div>
      </DashboardLayout>
    );
  }
  return (
    <DashboardLayout activePage="/organizations" entityId={orgData?.organizationId || id} rightcomponent={ <Button variant={"outline"} onClick={() => nav(-1)}>
            <ArrowLeft /> Back to organizations
          </Button>}>
      <div className="min-h-screen">
        {/* Header */}
        <div className="mb-6 flex items-center justify-between">
          <h1 className="text-3xl font-bold text-gray-900 capitalize">
            {orgData.organizationName}
          </h1>
                  <div className="flex flex-wrap gap-3 ">
          {actionButtons.map((button, index) => {
            const Icon = button.icon;
            return (
              <Button
                onClick={button?.onClick ? button.onClick : () => {}}
                key={index}
                className={`${button.color} px-4 py-2.5 rounded-lg font-medium text-sm transition-all shadow-sm hover:shadow flex items-center space-x-2`}
              >
                <Icon className="w-4 h-4" />
                <span>{button.label}</span>
              </Button>
            );
          })}
        </div>
          {/* <Button variant={"outline"} onClick={() => nav(-1)}>
            <ArrowLeft /> Back to organizations
          </Button> */}
        </div>

        {/* Stats Grid */}
        <LoaderWrapper
          loading={statsLoading}
          error={statsErr}
          customLoaderComponent={<DashboardcardShimmer count={4} isSmall />}
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 ">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <div
                  key={index}
                  onClick={() => {
                    stat?.onClick && stat?.onClick();
                  }}
                  className="bg-white rounded-xl p-4 shadow-sm border cursor-pointer border-gray-100 hover:shadow-md transition-shadow flex justify-between "
                >
                  <div>
                    <div className="text-3xl font-bold text-gray-900 mb-1">
                      {stat.count}
                    </div>
                    <div className="text-sm text-gray-600 font-medium">
                      {stat.label}
                    </div>
                  </div>
                  <div className="flex items-center justify-between ">
                    <div className={`${stat.color} p-3 rounded-lg`}>
                      <Icon className="w-6 h-6" />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </LoaderWrapper>

        {/* Organization Details Section */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 mt-8">
          <div className="border-b border-gray-200 px-6 py-4 flex items-center justify-between">
            <h2 className="text-xl font-bold text-gray-900">
              Organization Details
            </h2>
            <Button
              variant={"outline"}
              onClick={() => setIsEditDialogOpen(true)}
            >
              <Edit /> Edit Organization{" "}
            </Button>
          </div>
          {/* Tabs */}
          <div className="border-b border-gray-200 bg-gray-50">
            <div className="flex space-x-1 px-6">
              {tabs.map((tab) => (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`px-6 py-3 font-medium text-sm transition-colors relative ${
                    activeTab === tab.id
                      ? "text-blue-600 bg-white"
                      : "text-gray-600 hover:text-gray-900"
                  }`}
                >
                  {tab.label}
                  {activeTab === tab.id && (
                    <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600"></div>
                  )}
                </button>
              ))}
            </div>
          </div>
          {/* Tab Content */}
          <div className="p-6">
            {activeTab === "general" && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-6">
                <InfoRow
                  label="Provider's Name"
                  value={`${orgData.ownerFirstName || ""} ${orgData.ownerMiddleName || ""} ${orgData.ownerLastName || ""}`}
                />
                <InfoRow
                  label="Facility / Organization"
                  value={orgData.organizationName}
                />
                <InfoRow
                  label="Provider / Group NPI"
                  value={orgData.providerGroupNPI}
                />
                <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
                  <InfoRow
                    label="Phone no."
                    value={formatUSPhoneNumber(orgData.phoneNumber)}
                    
                  />
                  {/* {orgData.phoneNumber} */}
                  <InfoRow label="Email" value={orgData.email}  />
                </div>
                <InfoRow label="Address " value={orgData.address || "-"} />
                <InfoRow label="Street " value={orgData.street || "-"} />
                <InfoRow label="State" value={orgData.state || "-"} />
                <InfoRow label="City" value={orgData.city || "-"} />
                <InfoRow label="Zip code" value={orgData.zipCode || "-"} />
                <InfoRow
                  label="Timezone"
                  value={formatOrganizationTimezoneDisplay(
                    orgData.timezone ?? orgData.timeZone,
                  )}
                />
              </div>
            )}
            {activeTab === "biller" && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-6">
                <InfoRow
                  label="Name"
                  value={`${orgData.billerFirstName || ""} ${orgData.billerMiddleName || ""} ${orgData.billerLastName || ""}`}
                />
                <InfoRow
                  label="Email"
                  value={orgData.billerEmail || "-"}
                />
                <InfoRow
                  label="Phone"
                  value={formatUSPhoneNumber( orgData.billerPhoneNumber || "-")}
                />
                <InfoRow
                  label="Location"
                  value={orgData.billerLocation || "-"}
                />
                <InfoRow
                  label="Street"
                  value={orgData.billerStreet || "-"}
                />
                <InfoRow
                  label="State"
                  value={orgData.billerState || "-"}
                />
                <InfoRow
                  label="City"
                  value={orgData.billerCity || "-"}
                />
                <InfoRow
                  label="Zip Code"
                  value={orgData.billerZipCode || "-"}
                />
              </div>
            )}
            {activeTab === "billing" && (
              <>
                {/* Billing Details */}
                <div className="rounded-xl border bg-white p-6 shadow-sm">
                  <h3 className="text-xl font-semibold mb-6">
                    Billing Details
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-6">
                    <InfoRow
                      label="Address"
                      value={orgData.billingAddress || "-"}
                    />
                    <InfoRow
                      label="Street"
                      value={orgData.billingStreet || "-"}
                    />
                    <InfoRow
                      label="City"
                      value={orgData.billingCity || "-"}
                    />
                    <InfoRow
                      label="State"
                      value={orgData.billingState || "-"}
                    />
                    <InfoRow
                      label="Zip Code"
                      value={orgData.billingZipCode || "-"}
                    />
                  </div>
                </div>

                {/* Taxation Details */}
                <div className="rounded-xl border bg-white p-6 shadow-sm mt-10">
                  <h3 className="text-xl font-semibold mb-6">
                    Taxation Details
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-10 gap-y-6">
                    <InfoRow
                      label="Taxonomy Code"
                      value={orgData.taxonomyCode || "-"}
                    />
                    <InfoRow
                      label="Medical ID"
                      value={orgData.medicalId || "-"}
                    />
                    <InfoRow label="TIN" value={orgData.tin || "-"} />
                    <InfoRow
                      label="Trading Partner ID"
                      value={orgData.tradingPartnerId || "-"}
                    />
                    <InfoRow label="PTAN" value={orgData.ptan || "-"} />
                    <InfoRow
                      label="Group NPI"
                      value={orgData.groupNPI || "-"}
                    />
                    <InfoRow
                      label="Group Tax ID"
                      value={orgData.groupTaxId || "-"}
                    />
                    <InfoRow
                      label="Group Name"
                      value={orgData.groupName || "-"}
                    />
                  </div>
                </div>
              </>
            )}
            {activeTab === "display" && (
              <div className="text-center py-12">
                <div className="w-32 h-32 bg-gray-200 rounded-full mx-auto mb-4 flex items-center justify-center">
                  <Building2 className="w-16 h-16 text-gray-400" />
                </div>
                <button className="px-6 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors">
                  Upload Picture
                </button>
              </div>
            )}
            {activeTab === "facilities" && (
              <FacilitiesList
                facilities={facilities}
                loading={facLoading}
                err={facErr}
                handleView={handleView}
                handleEdit={handleEdit}
                setFacilities={setFacilities}
                id={id}
              />
            )}
            {activeTab === "settings" && (
              <div className="text-center py-12 text-gray-500">
                <p>Default settings configuration coming soon...</p>
              </div>
            )}
          </div>
        </div>
      </div>
      <Dialog
        open={isEditDialogOpen}
        onOpenChange={(open) => {
          setIsEditDialogOpen(open);
        }}
      >
        <OrganizationForm
          key={id}
          defaultValues={orgData}
          isOpen={isEditDialogOpen}
          onClose={() => {
            setIsEditDialogOpen(false);
            // setSelectedOrg({});
          }}
          heading={"Edit Organizations "}
          btnLoading={btnLoading}
          onSubmit={handleAddUpdateOrg}
        />
      </Dialog>
      {/* Add facility */}
      <Dialog
        open={isFacilityPopupOpen}
        onOpenChange={(open) => {
          setIsFacilityPopupOpen(open);
        }}
      >
        <MyDialogContent heading="Add Facility">
          <RHFWrapper
            initialValues={{
              organizationId: orgData?._id,
              organizationName: orgData?.organizationName,
              timezone:
                orgData?.timezone ?? orgData?.timeZone ?? "America/New_York",
            }}
            isValidate={false}
            validateSchema={{}}
            className="space-y-3 py-1"
            onSubmit={handleAddfacility}
          >
            <Grid count={1} gap={3}>
              <RhfInput name="name" isAlphabet label="Facility Name" required />
              <RhfSelect
                name="timezone"
                label="Timezone"
                options={facilityTimezoneOptions}
                defaultvalue={
                  orgData?.timezone ??
                  orgData?.timeZone ??
                  "America/New_York"
                }
              />
              {/* <RhfInput
                name="organizationName"
                isAlphabet
                label="Organization Name"
                required
                disabled={true}
              /> */}
            </Grid>
            <CityStateZipcode
              componentBefore={

 <RhfAddressAutoComplete
 key={'street'}
        name="street"
        label="Street"
        onAddressSelect={(data :any) => {}}
        required
        placeholder="Street, Apartment, etc."
        modifyValuesMapping={{
          // address: "address1",
          street: "address1",
          city: "city",
          state: "state",
          zipcode: "zipcode",
        }}
      />
                // <RhfInput
                //   name="street"
                //   // isAlphabet
            
                //   label="Street"
                //   required
                //   // disabled={true}
                // />
              }
              cityName="city"
              stateName="state"
              zipcodeName="zipcode"
              count={2}
              gap={3}
            />

            {/* <RhfInput
                name="city"
                isAlphabet
                label="City"
                required
                // disabled={true}
              />
              <RhfInput name="state" isAlphabet label="State" required />
              <RhfInput
                name="zipcode"
                isNumber
                maxLength={5}
                label="Zipcode"
                required
              /> */}
            <UnitAndRoom />
            <div className="flex items-center justify-end gap-2 sticky bottom-0 ">
              <Button
                variant={"outline"}
                type="button"
                onClick={() => setIsFacilityPopupOpen(false)}
              >
                Cancel
              </Button>
              <Button type="submit" disabled={btnLoading}>
                Submit
              </Button>
            </div>
          </RHFWrapper>
        </MyDialogContent>
      </Dialog>
      {/* Facility View/Edit Dialog */}
      <Dialog
        open={facilityDialogOpen}
        onOpenChange={(open) => {
          setFacilityDialogOpen(open);
          if (!open) {
            setFacilityMode("view");
            setSelectedFacility(null);
          }
        }}
      >
        <MyDialogContent
          heading={`${facilityMode === "view" ? "View" : "Edit"} ${selectedFacility?.name || "Facility"}`}
        >
          {facilityMode === "view" ? (
            <div className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-6">
                <InfoRow
                  label="Facility Name"
                  value={selectedFacility?.name || "-"}
                />
                <InfoRow
                  label="Organization Name"
                  value={
                    selectedFacility?.organizationId?.organizationName || "-"
                  }
                />
                <InfoRow
                  label="Street"
                  value={selectedFacility?.street || "-"}
                />
                <InfoRow label="City" value={selectedFacility?.city || "-"} />
                <InfoRow label="State" value={selectedFacility?.state || "-"} />
                <InfoRow
                  label="Timezone"
                  value={formatOrganizationTimezoneDisplay(
                    selectedFacility?.timezone ?? selectedFacility?.timeZone,
                  )}
                />
                <InfoRow
                  label="Zipcode"
                  value={selectedFacility?.zipcode || "-"}
                />
              </div>
              {selectedFacility?.units && selectedFacility.units.length > 0 && (
                <div className="mt-6">
                  <h3 className="text-lg font-bold mb-4 text-gray-900">
                    Units and Rooms
                  </h3>
                  {selectedFacility.units.map((unit: any, index: number) => (
                    <div
                      key={index}
                      className="bg-gray-50 border-l-4 border-primary p-4 rounded-lg mb-4"
                    >
                      <p className="font-medium">Unit: {unit.unit || "N/A"}</p>
                      <p className="mt-1">
                        Bed Locations: {unit.bedLocation?.join(", ") || "None"}
                      </p>
                      <p className="mt-1">
                        Rooms: {unit.rooms?.join(", ") || "None"}
                      </p>
                    </div>
                  ))}
                </div>
              )}
              <div className="flex justify-end pt-4 border-t">
                <Button
                  onClick={() => setFacilityMode("edit")}
                  variant="outline"
                >
                  <Edit className="w-4 h-4 mr-2" />
                  Edit
                </Button>
              </div>
            </div>
          ) : (
            <RHFWrapper
              initialValues={{
                ...selectedFacility,
                timezone:
                  selectedFacility?.timezone ??
                  selectedFacility?.timeZone ??
                  orgData?.timezone ??
                  orgData?.timeZone ??
                  "America/New_York",
              }}
              isValidate={false}
              validateSchema={{}}
              className="space-y-3 py-1"
              onSubmit={handleUpdateFacility}
            >
              <Grid count={1} gap={3}>
                <RhfInput
                  name="name"
                  isAlphabet
                  label="Facility Name"
                  required
                />
                <RhfSelect
                  name="timezone"
                  label="Timezone"
                  options={facilityTimezoneOptions}
                  defaultvalue={
                    selectedFacility?.timezone ??
                    selectedFacility?.timeZone ??
                    orgData?.timezone ??
                    orgData?.timeZone ??
                    "America/New_York"
                  }
                />
                {/* <RhfInput
                  name="organizationId"
                  isAlphabet
                  label="Organization Id"
                  required
                  disabled={true}
                  /> */}
              </Grid>
              <CityStateZipcode
                cityName="city"
                stateName="state"
                zipcodeName="zipcode"
                count={2}
                gap={3}
                componentBefore={
                  <RhfInput name="street" label="Street" required />
                }
              />
              {/* <RhfInput name="city" isAlphabet label="City" required />
                <RhfInput name="state" isAlphabet label="State" required />
                <RhfInput
                  name="zipcode"
                  isNumber
                  maxLength={5}
                  label="Zipcode"
                  required
                /> */}
              <UnitAndRoom defaultValues={selectedFacility} />
              <div className="flex items-center justify-end gap-2 sticky bottom-0 ">
                <Button
                  type="button"
                  variant={"outline"}
                  onClick={() => setFacilityDialogOpen(false)}
                >
                  Cancel
                </Button>
                <Button type="submit" disabled={btnLoading}>
                  Update Facility
                </Button>
              </div>
            </RHFWrapper>
          )}
        </MyDialogContent>
      </Dialog>

      <Dialog open={isBulkUploadOpen} onOpenChange={setIsBulkUploadOpen}>
        <MyDialogContent heading="Bulk Upload Patients" className="md:w-md">
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">
              Download the Excel template, fill in patient data, and upload it
              to add multiple patients at once.
            </p>
{/* <p className="bg-primary/15 text-primary text-xs px-3 py-1.5 rounded-md">
   Firstname, lastname, date of birth, gender, email, patient type is required.
</p> */}
            <div className="space-y-3">
              <Button
                variant="outline"
                className="w-full"
                onClick={downloadTemplate}
              >
                <Download className="w-4 h-4 mr-2" />
                Template
              </Button>

              <div className="space-y-2">
                <Label>Upload Filled Template</Label>
                <Input
                  id="file-upload"
                  ref={fileInputRef}
                  type="file"
                  accept=".xlsx,.xls"
                  onChange={handleFileUpload}
                  disabled={isUploading}
                />
              </div>
            </div>

            {isUploading && (
              <div className="text-center py-4">
                <p className="text-sm text-muted-foreground">
                  Processing file...
                </p>
              </div>
            )}

            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
              <p className="text-xs text-blue-900">
                <strong>Note:</strong> {" "}
                {/* Make sure to fill in all required fields
                marked with * in the template. You can find Organization IDs and
                Provider IDs in their respective management pages. */}
                 Firstname, lastname, date of birth, gender, email, patient type is required.
              </p>
            </div>
          </div>
        </MyDialogContent>
      </Dialog>

      {/* Upload errors popup - errors dikhane ke liye */}
      <Dialog open={isUploadErrorsOpen} onOpenChange={setIsUploadErrorsOpen}>
        <MyDialogContent heading="Upload Errors" className="md:max-w-lg">
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground">
              {uploadErrors.length} row(s) could not be uploaded. Please fix the errors and upload again.
            </p>
            <div className="rounded-md border border-destructive/30 bg-destructive/5 max-h-[60vh] overflow-auto">
              <table className="w-full text-sm">
                <thead className="sticky top-0 bg-muted/80 border-b">
                  <tr>
                    <th className="text-left font-medium px-4 py-3">Row</th>
                    <th className="text-left font-medium px-4 py-3">Error</th>
                  </tr>
                </thead>
                <tbody>
                  {uploadErrors.map((item, index) => (
                    <tr key={index} className="border-b border-border/50 last:border-0">
                      <td className="px-4 py-2.5 font-medium">{item.row}</td>
                      <td className="px-4 py-2.5 text-destructive">{item.error}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="flex justify-end">
              <Button onClick={() => setIsUploadErrorsOpen(false)}>Close</Button>
            </div>
          </div>
        </MyDialogContent>
      </Dialog>
    </DashboardLayout>
  );
};
const InfoRow = ({ label, value, required }: any) => (
  <div className="flex flex-col space-y-1.5">
    <label className="text-sm font-medium text-gray-600">
      {label}
      {required && <span className="text-red-500 ml-1">*</span>}
    </label>
    <div className="text-base text-gray-900 font-medium">{value || "-"}</div>
  </div>
);
const UnitAndRoom = ({ defaultValues }: any) => {
  const methods = useFormContext();
  const { control } = methods;
  const { fields, append, remove } = useFieldArray({
    control,
    name: "units",
  });

  // Add initial unit if none exists
  React.useEffect(() => {
    if (fields.length === 0) {
      append({
        unit: "",
        bedLocation: [],
        rooms: [],
      });
    }
  }, []);
  const handleAddUnit = () => {
    append({
      unit: "",
      bedLocation: "",
      rooms: [],
    });
  };
  const bedLocationOptions = [
    { label: "Door", value: "door" },
    { label: "Window", value: "window" },
    { label: "Private", value: "private" },
    { label: "A", value: "A" },
    { label: "B", value: "B" },


  ];
  const roomOptions = [
    { label: "101", value: "101" },
    { label: "102", value: "102" },
    { label: "103", value: "103" },
    { label: "104", value: "104" },
  ];
  return (
    <div className="bg-white rounded-lg p-0">
      <div className="mb-2">
        <h2 className="text-lg font-bold text-gray-900">
          Add Facility units and room
        </h2>
      </div>
      <div className="space-y-6">
        {fields.map((field, index) => (
          <div
            key={field.id}
            className="relative border-l-4 border-primary px-2 pt-5 py-4 bg-gray-50 rounded-r-lg"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4">
              {/* Unit / Floor — single creatable select */}
              <RhfSelect
                name={`units.${index}.unit`}
                placeholder="Enter the Unit"
                options={[]}
                defaultvalue={defaultValues?.units?.[index]?.unit ?? ""}
                label="Unit / Floor"
                customLine="Add unit  "
                isCustomSelect
              />
              {/* Bed Locations Select */}
              <RhfSelect
                name={`units.${index}.bedLocation`}
                placeholder="Enter The Bed Locations"
                options={bedLocationOptions}
                defaultvalue={defaultValues?.units?.[index]?.bedLocation}
                label="Bed Locations"
                multiple
                  customLine="Add bed location  "
                isCustomSelect
              />
            </div>
            <div className="grid grid-cols-1 gap-6">
              {/* Rooms Select */}
              <RhfSelect
                name={`units.${index}.rooms`}
                placeholder="Enter the Room Numbers"
                options={roomOptions}
                defaultvalue={defaultValues?.units?.[index]?.rooms}
                customLine="Add room no. "
                label="Rooms"
                multiple
                isCustomSelect
              />
            </div>
            {/* Action Buttons */}
            <div className="absolute top-1 right-1 flex gap-2">
              {index === 0 && fields.length === 1 ? (
                // <button
                //   type="button"
                //   className="p-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                //   title="Edit"
                // >
                //   <Edit2 className="w-3 h-3" />
                // </button>
                <></>
              ) : (
                <button
                  type="button"
                  onClick={() => remove(index)}
                  className="p-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
                  title="Remove Unit"
                >
                  <Trash2 className="w-3 h-3" />
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
      {/* Add More Unit Button */}
      <button
        type="button"
        onClick={handleAddUnit}
        className="mt-6 px-2 py-1 text-sm bg-white border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors flex items-center gap-2 font-medium"
      >
        <Plus className="w-4 h-4" />
        Add One More Unit
      </button>
      {/* Save Button */}
    </div>
  );
};
const FacilitiesList = ({
  facilities,
  loading,
  err,
  handleView,
  handleEdit,
  setFacilities,
  id
}: any) => {
  return (
    <div className="space-y-3 p-0">
      <LoaderWrapper
        loading={loading}
        error={err}
        customLoaderComponent={<HorizontalCardShimmer count={4} />}
      >
       <TableWithSearch
        fetchCondition={true}
        heading=""
        isIncludeSearch
        isColumnSelection
        columnPreferenceKey={`org-facilities-${id}`}
        apiDataKey="facilities"
        columnHeaders={facilitiesTableHeaders}
        
        searchPlaceholder="Search facilties"
        url="/facilities"
        params={{ orgId: id }}
        data={facilities}
        viewData={facilities.map((f: any) => ({
          ...f,
          timezoneDisplay: formatOrganizationTimezoneDisplay(
            f?.timezone ?? f?.timeZone,
          ),
        }))}
        
        setData={setFacilities}
        isActionColumn
        handleAction={(data)=> { handleEdit(data)}}
        // clickRow={(data:any)=> nav(data?._id,{state: {data}})}
        moreActions={[
          {
            label: "View ",
            icon: <Eye />,
            onClick:handleView,
            isShow: ()=> true
          },
        ]}
        filters={[]}
        clickRow={()=>{}}
        filtersOptions={[]}
        setFilters={()=> {}}
     



      />
      </LoaderWrapper>
    </div>
  );
};

export default OrganizationProfile;


    // {facilities.map((facility: any) => (
    //       <Card
    //         key={facility._id}
    //         className="overflow-hidden hover:shadow-md transition-shadow"
    //       >
    //         <div className="flex items-center justify-between px-4">
    //           <div className="flex items-center gap-4 flex-1 min-w-0">
    //             <div className="shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
    //               <Building2 className="w-5 h-5 text-primary" />
    //             </div>
    //             <div className="flex-1 min-w-0">
    //               <h3 className="font-semibold text-foreground truncate">
    //                 {facility.name}
    //               </h3>
    //               {facility.location && (
    //                 <div className="flex items-center gap-1 mt-1 text-sm text-muted-foreground">
    //                   <MapPin className="w-3 h-3" />
    //                   <span className="truncate">{facility.location}</span>
    //                 </div>
    //               )}
    //             </div>
    //           </div>
    //           <div className="flex items-center gap-2 ml-4">
    //             <Button
    //               variant="ghost"
    //               size="icon"
    //               onClick={() => handleView(facility)}
    //               className="hover:bg-primary/10 hover:text-primary"
    //               title="View details"
    //             >
    //               <Eye className="w-4 h-4" />
    //             </Button>
    //             <Button
    //               variant="ghost"
    //               size="icon"
    //               onClick={() => handleEdit(facility)}
    //               className="hover:bg-primary/10 hover:text-primary"
    //               title="Edit facility"
    //             >
    //               <Pencil className="w-4 h-4" />
    //             </Button>
    //           </div>
    //         </div>
    //       </Card>
    //     ))}